import React from 'react';
import PropTypes from 'prop-types';

import { Link, RowContainer } from '../../shared/styles';
import { ActionColumn } from '../../companies/companies-components/styles';
import { NameColumn, PositionColumn } from './styles';

export default function Partner({ member }) {
  const {
    name,
    position,
    userId,
  } = member;

  return (
    <RowContainer>
      <NameColumn>{name}</NameColumn>
      <PositionColumn>{position}</PositionColumn>
      <ActionColumn>
        <Link href={`/admin/users/${userId}`}>View User</Link>
      </ActionColumn>
    </RowContainer>
  );
}

Partner.propTypes = {
  member: PropTypes.shape({
    name: PropTypes.string,
    position: PropTypes.string,
    userId: PropTypes.number,
  }).isRequired,
};
